const noop = () => undefined;

export const useSaveHaptics = () => ({
  playExistingSave: noop,
  playNewSave: noop,
});
